var map = {
	"./fondo/Fondo_Main_menu.png": "1303",
	"./fondo/Grupo30.png": "fcac",
	"./imagenes_compartidas/Cerrar_Ventana.png": "7ad5",
	"./imagenes_compartidas/Flecha_Derecha_Dialogos.png": "ecb9",
	"./imagenes_compartidas/Flecha_Derecha_Paginas.png": "4d2a",
	"./imagenes_compartidas/Flecha_Izquierda_Dialogos.png": "c696",
	"./imagenes_compartidas/Flecha_Izquierda_Paginas.png": "1658",
	"./imagenes_compartidas/abc.png": "79d6",
	"./imagenes_compartidas/boton-info.png": "bb09",
	"./imagenes_compartidas/tucan-0.png": "4dd4",
	"./imagenes_compartidas/tucan-1.png": "5e91",
	"./imagenes_compartidas/tucan-2.png": "dcce",
	"./presentacion/unidad-1.png": "3fab",
	"./presentacion/unidad-2.png": "7973",
	"./presentacion/unidad-3.png": "66de",
	"./presentacion/unidad-4.png": "766a",
	"./unidad1/slide-1/A.png": "5096",
	"./unidad1/slide-1/B.png": "d9c9",
	"./unidad1/slide-1/C.png": "f804",
	"./unidad1/slide-1/D.png": "4036",
	"./unidad1/slide-1/E.png": "7a78",
	"./unidad1/slide-1/F.png": "14f1",
	"./unidad1/slide-1/G.png": "9ea3",
	"./unidad1/slide-1/H.png": "ccac",
	"./unidad1/slide-1/I.png": "2304",
	"./unidad1/slide-1/J.png": "a714",
	"./unidad1/slide-1/K.png": "3422",
	"./unidad1/slide-1/L.png": "b8ab",
	"./unidad1/slide-1/M.png": "3bc2",
	"./unidad1/slide-1/N.png": "296f",
	"./unidad1/slide-1/O.png": "5922",
	"./unidad1/slide-1/P.png": "f350",
	"./unidad1/slide-1/Q.png": "f8df",
	"./unidad1/slide-1/R.png": "7a66",
	"./unidad1/slide-1/S.png": "4778",
	"./unidad1/slide-1/T.png": "cefe",
	"./unidad1/slide-1/U.png": "c9a6",
	"./unidad1/slide-1/V.png": "2fc8",
	"./unidad1/slide-1/W.png": "8799",
	"./unidad1/slide-1/X.png": "9b73",
	"./unidad1/slide-1/Y.png": "a572",
	"./unidad1/slide-1/Z.png": "abc4",
	"./unidad1/slide-17/slide-17-1.png": "dd36",
	"./unidad1/slide-17/slide-17-2.png": "b486",
	"./unidad1/slide-17/slide-17-3.png": "efd9",
	"./unidad1/slide-17/slide-17-4.png": "f19b",
	"./unidad1/slide-17/slide-17-5.png": "fec6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "61b9";